import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import { AppBarTitle } from '@components/app-bar-title';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { FcSearch, HandShakeIcon } from '@icon/react-icons';
import { Link } from 'react-router-dom';
import { AvatarProps, Avatar, IconButton, Grid, Tooltip, Box } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/House';

const useStyles = makeStyles({
  root: {
    // maxWidth: 200,
    // boxShadow:
    //   '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),0px 1px 5px 0px rgb(0 0 0 / 12%)',
  },
  media: {
    height: 150,
  },
});

export interface CardProps {
  imageUrl: string;
  cardLabel: string;
  buttons?: { route: string; label: string }[];
  subCards?: { cardLabel: string; label: string; route: string }[];
  backgroundSize?: 'cover' | 'contain';
}
export function PageCard({ imageUrl, cardLabel, buttons,subCards, backgroundSize = null }: CardProps) {
  const classes = useStyles();

  return (
    <Card
      className={classes.root}
      elevation={5}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        width: '100%',
      }}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={imageUrl}
          title={cardLabel}
          style={{
            backgroundSize: backgroundSize ? backgroundSize : 'contain',
            backgroundPosition: 'center center',
          }}
        />
       {buttons && <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {cardLabel}
          </Typography>
       
        </CardContent>}
        {subCards && <CardContent  style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            gap: 2,
          }}>
            {subCards.map((item, index) => (
          <Typography gutterBottom variant="h5" component="h2"  style={{
          textAlign: index === 0 ? 'left' : 'right',
        //  width: '50%', // each label takes half width
        }}>
            {item?.cardLabel}
          </Typography>
           ))}
        
        </CardContent>}
      </CardActionArea>
   
       {/* ✅ Regular buttons */}
      {buttons && (
        <CardActions>
          {buttons.map((x, index) => (
            <Link to={x.route} style={{ textDecoration: 'none' }} key={index}>
              <Button size="small" color="primary" className={x.route.slice(1).replace('/', '-')}>
                {x.label}
              </Button>
            </Link>
          ))}
        </CardActions>
      )}

      {/* ✅ SubCards for Database Logs & Secondary Logs */}
       {subCards && (
        <CardActions
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
           
          }}
        >
          {subCards.map((item, index) => (
            <Box key={index} textAlign={index === 0 ? 'left' : 'right'}>
              <Link to={item.route} style={{ textDecoration: 'none' }}>
                <Button size="small" color="primary" className={item.route.slice(1).replace('/', '-')}>
                  {item.label}
                </Button>
              </Link>
            </Box>
          ))}
        </CardActions>
      )}
    </Card>
  );
}

const allCategories: CardProps[] = [
  {
    imageUrl: '/images/Deals.jpg',
    cardLabel: 'Deals Intel',
    buttons: [
      {
        label: 'Search',
        route: '/deals/search',
      },
      {
        label: 'New',
        route: '/deals/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Companies.jpg',
    cardLabel: 'Companies',
    buttons: [
      {
        label: 'Search',
        route: '/company/search',
      },
      {
        label: 'New',
        route: '/company/new',
      },
      {
        label: 'Search Request',
        route: '/company-request/search',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/content.jpg',
    cardLabel: 'Content',
    buttons: [
      {
        label: 'Search',
        route: '/content/search',
      },
      {
        label: 'New',
        route: '/content/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Person.jpg',
    cardLabel: 'People',
    buttons: [
      {
        label: 'Search',
        route: '/person-management/search',
      },
      {
        label: 'New',
        route: '/person-management/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Company to Content.jpg',
    cardLabel: 'Company to Content Relations',
    buttons: [
      {
        label: 'Search',
        route: '/company-content-beta/search',
      },
      {
        label: 'New',
        route: '/company-content/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Company to Company.jpg',
    cardLabel: 'Company to Company Relations (C2C)',
    buttons: [
      {
        label: 'Search',
        route: '/company-mapping/search',
      },
      {
        label: 'New',
        route: '/company-mapping/new',
      },
    ],
    backgroundSize: 'cover',
  },
 {
    imageUrl: '/images/CompanyToPerson.jpg',
    cardLabel: 'Company To Person Relations (C2P)',
    buttons: [
      {
        label: 'Search',
        route: '/company-person/search',
      },
      {
        label: 'New',
        route: '/company-person/add',
      },
    ],
    backgroundSize: 'cover',
  },
  {
  imageUrl: '/images/content.jpg',
    cardLabel: 'Content to Person Relations (C3)',
    buttons: [
      {
        label: 'Search',
        route: '/c3-page/search',
      },
      {
        label: 'New',
        route: '/c3-page/add',
      },
    ],
    backgroundSize: 'cover',
  },
   {
  imageUrl: '/images/content.jpg',
    cardLabel: 'Content to Content Relations (C2)',
    buttons: [
      {
        label: 'Search',
        route: '/content-mapping/search',
      },
      {
        label: 'New',
        route: '/content-mapping/new',
      },
    ],
    backgroundSize: 'cover',
  },
   {
    imageUrl: '/images/Cosmos API.jpg',
    cardLabel: 'COSMOS',
    buttons: [
      {
        label: 'Search',
        route: '/holding-data/search',
      },
      {
        label: 'Seller Catalogue',
        route: '/seller-catalog/search',
      },
    ],
    backgroundSize: 'cover',
  },
   {
    imageUrl: '/images/Cosmos API.jpg',
    cardLabel: 'Matching & Mapping',
    buttons: [
      {
        label: 'Company',
        route: '/company-matching/search',
      },
      /*  {
        label: 'Person',
        route: '/company-matching/search',
      },*/
       {
        label: 'Content',
        route: '/content-matching/search',
      }, 
    ],
    backgroundSize: 'cover',
  },
    {
    imageUrl: '/images/Cosmos API.jpg',
    cardLabel: 'Duplicate Spotter',
    buttons: [
      {
        label: 'Content',
        route: '/duplicate-spotter/content',
      },
      /*  {
        label: 'Person',
        route: '/company-matching/search',
      },*/
    ],
    backgroundSize: 'cover',
  },
   {
    imageUrl: '/images/CompanyToPerson.jpg',
    cardLabel: 'Domains Management',
    buttons: [
      {
        label: 'Search',
        route: '/domain-blacklist/search',
      },
      {
        label: 'New',
        route: '/domain-blacklist/add',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Service Management.jpg',
    cardLabel: 'Services Management',
    buttons: [
      {
        label: 'Search',
        route: '/service-management/search',
      },
      {
        label: 'New',
        route: '/service-management/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Badge.jpg',
    cardLabel: 'Badges Management',
    buttons: [
      {
        label: 'Search',
        route: '/badge-management/search',
      },
      {
        label: 'New',
        route: '/badges-management/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Deal Sub Type Management.jpg',
    cardLabel: 'Deal SubType Management',
    buttons: [
      {
        label: 'Search',
        route: '/deal-subtype-master/search',
      },
      {
        label: 'New',
        route: '/deal-subtype-master/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Region Country Management.jpg',
    cardLabel: 'Territory Management',
    buttons: [
      {
        label: 'Search',
        route: '/region-country-master/search',
      },
      {
        label: 'New',
        route: '/region-country-master/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/CompanyToPerson.jpg',
    cardLabel: 'Database Logs',
    subCards: [
    {
        cardLabel: 'Database Logs',
        label: 'Search',
        route: '/database-logs/search',
      },
      {
        cardLabel: 'Secondary Logs',
        label: 'Search',
        route: '/database-logs-secondary/search',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Companies.jpg',
    cardLabel: 'Company Reputation Score',
    buttons: [
      {
        label: 'Admin',
        route: '/company-reputation-score',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Service Management.jpg',
    cardLabel: 'S3 Manager',
    buttons: [
      {
        label: 'Manage',
        route: '/s3-manager',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Companies.jpg',
    cardLabel: 'Quotes & Policies',
    buttons: [
      {
        label: 'Search',
        route: '/quotes-policies/search',
      },
       {
        label: 'New',
        route: '/quotes-policies/new',
      },
    ],
    backgroundSize: 'cover',
  },
];
export function LandingPage() {
  return (
    <div>
      <AppBarTitle>
        <IconButton onClick={null} color="inherit" edge="start">
          <HomeIcon />
        </IconButton>
        Welcome to DELI
      </AppBarTitle>
      <Grid container alignItems="stretch" spacing={2} justify="center">
        {allCategories.map((val, index) => (
          <Grid item xs={3} style={{ display: 'flex' }} key={index}>
            <PageCard
              imageUrl={val.imageUrl}
              cardLabel={val.cardLabel}
              buttons={val.buttons}
              subCards={val.subCards}
              backgroundSize={val.backgroundSize}
              key={index}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
